import React, { useState } from "react";
import { User, Mail, Phone, MessageSquare, AlertCircle } from "lucide-react";
import "../styles/Contact.css";

export default function Contact({ isOpen, onClose }) {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [errors, setErrors] = useState({});

  if (!isOpen) return null;

  const validate = () => {
    const newErrors = {};

    if (!form.name.trim()) newErrors.name = "Le nom est requis";
    
    if (!form.phone.trim()) newErrors.phone = "Le téléphone est requis";

    if (!form.email.trim()) newErrors.email = "L'email est requis";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email))
      newErrors.email = "Format d'email invalide";

    if (!form.message.trim()) newErrors.message = "Le message est requis";

    return newErrors;
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    alert("Formulaire envoyé !");
    onClose();
  };

  const renderInput = (label, name, type, Icon) => (
    <div className="contact-field">
      <label htmlFor={name}>
        <Icon size={16} style={{ marginRight: "6px" }} />
        {label}
      </label>
      <div className="input-wrapper">
        {type === "textarea" ? (
          <textarea
            id={name}
            name={name}
            rows={4}
            value={form[name]}
            onChange={handleChange}
            className={errors[name] ? "input-error" : ""}
          ></textarea>
        ) : (
          <input
            type={type}
            id={name}
            name={name}
            value={form[name]}
            onChange={handleChange}
            className={errors[name] ? "input-error" : ""}
          />
        )}
        {errors[name] && (
          <AlertCircle
            size={18}
            className="error-icon"
            title={errors[name]}
          />
        )}
      </div>
      {errors[name] && <div className="error-text">{errors[name]}</div>}
    </div>
  );

  return (
    <div className="contact-popup-overlay" onClick={onClose}>
      <div className="contact-popup" onClick={(e) => e.stopPropagation()}>
        <button className="quote-stepper-close contact-popup-close" onClick={onClose}>
          ✕
        </button>
        <h2>Contactez-nous</h2>
        <form onSubmit={handleSubmit}>
          {renderInput("Nom", "name", "text", User)}
          {renderInput("Email", "email", "email", Mail)}
          {renderInput("Téléphone", "phone", "tel", Phone)}
          {renderInput("Message", "message", "textarea", MessageSquare)}

          <button type="submit" className="contact-popup-submit">
            Envoyer
          </button>
        </form>
      </div>
    </div>
  );
}
